import { useMutation, useQuery } from '@apollo/client'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CreateInvoiceRow, RemoveInvoiceRow } from '../graphql/mutations'
import { GetInvoiceRows, SearchProduction } from '../graphql/queries'
import Button from './Button'
import SelectInput from './SelectInput'

const InvoiceRows = ({ invoiceId }) => {

    const { t } = useTranslation()
    const [rows, setRows] = useState([])
    const [rowHeaders, setRowHeaders] = useState([
        {
            value: 'product',
            label: t('Toodangu nr'),
        },
        {
            value: 'KLIENT_ORDER',
            label: t('Tellimus'),
        },
        {
            value: 'KLIENT_BOXCODE',
            label: t('Toote kood'),
        },
        {
            value: 'PRICE',
            label: t('Tüki hind'),
        },
        {
            value: 'ALUSEID',
            label: t('Aluseid'),
        },
        {
            value: 'ADDRESS',
            label: t('Transpordi aadress'),
        },
    ])
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [createInvoiceRow] = useMutation(CreateInvoiceRow)
    const [removeInvoiceRow] = useMutation(RemoveInvoiceRow)

    const { refetch } = useQuery(GetInvoiceRows, {
        variables: {
            invoiceId: parseInt(invoiceId),
        },
        onCompleted: (data) => {
            const { getInvoiceRows } = data
            if (getInvoiceRows) setRows(getInvoiceRows)
        }
    })

    const { refetch: searchProduction } = useQuery(SearchProduction, {
        skip: true,
    })

    const handleAddRow = async (prodId) => {
        try {
            await createInvoiceRow({
                variables: {
                    data: {
                        INVOICE_ID: parseInt(invoiceId),
                        PRODUCT_ID: parseInt(prodId),
                    },
                },
            })
            setSelectedProduct(null)
        } catch (err) {
            console.log('handleAddRow', err)
        }
    }

    const handleDeleteRow = async (id) => {
        try {
            const res = await removeInvoiceRow({
                variables: {
                    id: parseInt(id),
                },
            })
            refetch()
        } catch (err) {
            console.log('handleDeleteRow', err)
        }
    }

    const getColumnValue = (row, field) => {
        const { production } = row
        if (!production) return ''

        if (field === 'product') {
            return `${production.ORDERNO}, ${production.MOOT}, ${production.RKOGUS}, ${production.BOX}`
        }
        return production[field]
    }

    const loadProducts = async (input) => {
        if (input.length < 2) return
        const res = await searchProduction({
            searchInput: input,
        })
        return res.data.searchProduction
    }

    const handleAddProduct = async () => {
        if (selectedProduct && selectedProduct.ID) {
            await handleAddRow(selectedProduct.ID)
            refetch()
        }
    }

    const displayProductLabel = (option) => {
        return `${option.ORDERNO}, ${option.MOOT}${option.RKOGUS ? ', ' + option.RKOGUS : ''}${option.BOX ? ', ' + option.BOX : ''}`
    }

    return (
        <div className='invoice-rows'>
            <div className='product-search'>
                <h5>{ `${t('Toodete lisamine')}` }</h5>
                <div className='product-search--inner'>
                    <SelectInput
                        load={loadProducts}
                        value={selectedProduct}
                        getOptionLabel={displayProductLabel}
                        getOptionValue={(option) => option.ID}
                        loadingMessage={() => t('Laen tooteid')}
                        noOptionsMessage={() => t('Kirjuta, et otsida tooteid')}
                        placeholder={t('Otsi tooteid')}
                        onChange={(option) => setSelectedProduct(option)}
                    />
                    <Button
                        label={t('Lisa arvele')}
                        onClick={handleAddProduct}
                    />
                </div>
            </div>
            <div className='invoice-rows-list'>
                { rows.length > 0 ?
                    <table className='order-rows'>
                        <thead
                            className='order-rows--header'
                            style={{
                                gridTemplateColumns: `repeat(${rowHeaders.length}, 1fr)`
                            }}
                        >
                            <tr>
                            {
                                rowHeaders.map((headerItem) =>
                                    <th key={`header-${headerItem.value}`} className='order-rows--header-item'>
                                        { headerItem.label }
                                    </th>
                                )
                            }
                            <th></th>
                            </tr>
                        </thead>
                        <tbody className='order-rows--content'>
                            {
                                rows.map((row, index) =>
                                    <tr
                                        key={`order-row-${index}`}
                                        className={`order-row`}
                                        style={{
                                            gridTemplateColumns: `repeat(${rowHeaders.length}, 1fr)`
                                        }}
                                    >
                                        {
                                            rowHeaders.map((headerItem, itemIndex) =>
                                                <td
                                                    key={`order-row-${index}-${itemIndex}`}
                                                    className='order-row--item'
                                                >
                                                    { getColumnValue(row, headerItem.value) }
                                                </td>
                                            )
                                        }
                                        <td>
                                            <Button
                                                label={'Kustuta'}
                                                onClick={() => handleDeleteRow(row.ID)}
                                            />
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    :
                    <div className='empty-result'>
                        { t('Ühtegi rida pole lisatud') }
                    </div>
                }
            </div>
        </div>
    )
}

export default InvoiceRows